module.exports = __webpack_public_path__ + "img/Empowerment02-1000.15afa3a7.png";